import CabinRoundedIcon from '@mui/icons-material/CabinRounded';
import GiteRoundedIcon from '@mui/icons-material/GiteRounded';
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';
import NoMeetingRoomRoundedIcon from '@mui/icons-material/NoMeetingRoomRounded';
import Label from '../components/label/Label';

const dateToTimestamp = (dateTime) => {
  if (dateTime) {
    const date = new Date(dateTime);
    // Get the timestamp of the input date
    return date.getTime();
  }
  return null;
};

const isInInterval = (date, endDate) => {
  // Get the current timestamp
  const currentTimestamp = Date.now();
  if (date && endDate) {
    if (currentTimestamp <= dateToTimestamp(date) && currentTimestamp <= dateToTimestamp(endDate)) {
      return false;
    } else if (currentTimestamp >= dateToTimestamp(date) && currentTimestamp <= dateToTimestamp(endDate)) {
      return true;
    } else if (currentTimestamp >= dateToTimestamp(date) && currentTimestamp >= dateToTimestamp(endDate)) {
      return null;
    }
  } else if (date && !endDate) {
    if (currentTimestamp >= dateToTimestamp(date)) {
      return true;
    } else if (currentTimestamp <= dateToTimestamp(date)) {
      return false;
    }
  }
  return false;
};

const getStatus = (status) => {
  switch (status) {
    case true:
      return 'V priebehu';
    case false:
      return 'Plánované';
    case null:
      return 'Ukončené';
    default:
      return 'V priebehu';
  }
};

export const useFazy = () => {
  const fazy = ['hrubá stavba', 'holodom', 'na kľúč'];
  const stavy = ['plánované', 'v priebehu', 'ukončené'];
  const years = [
    '2015',
    '2016',
    '2017',
    '2018',
    '2019',
    '2020',
    '2021',
    '2022',
    '2023',
    '2024',
    '2025',
    '2026',
    '2027',
    '2028',
  ];
  const iconSet = (type, size) => {
    switch (type) {
      case 'hrubá stavba':
        return (
          <Label color={'primary'} startIcon={<CabinRoundedIcon />} sx={{ fontSize: size, padding: 2 }}>
            hrubá stavba
          </Label>
        );
      case 'holodom':
        return (
          <Label color={'warning'} startIcon={<GiteRoundedIcon />} sx={{ fontSize: size, padding: 2 }}>
            holodom
          </Label>
        );
      case 'na kľúč':
        return (
          <Label color={'success'} startIcon={<KeyRoundedIcon />} sx={{ fontSize: size, padding: 2 }}>
            na kľúč
          </Label>
        );
      default:
        return '';
    }
  };

  const statusSet = (zakazka) => {
    if (zakazka) {
      if (zakazka.faza === 'hrubá stavba') {
        let startDate = '';
        if (zakazka?.zakladovaDoskaDate) {
          startDate = zakazka?.zakladovaDoskaDate;
        } else if (zakazka?.hrubovaStavbaDate) {
          startDate = zakazka?.hrubovaStavbaDate;
        }

        const status = isInInterval(startDate, zakazka?.hrubovaStavbaDateEnd ?? '');

        return getStatus(status);
      } else if (zakazka.faza === 'holodom') {
        let startDate = '';
        if (zakazka?.zakladovaDoskaDate) {
          startDate = zakazka?.zakladovaDoskaDate;
        } else if (zakazka?.hrubovaStavbaDate) {
          startDate = zakazka?.hrubovaStavbaDate;
        } else if (zakazka?.holodomDate) {
          startDate = zakazka?.holodomDate;
        }
        const status = isInInterval(startDate, zakazka?.holodomDateEnd ?? '');

        return getStatus(status);
      } else if (zakazka.faza === 'na kľúč') {
        let startDate = '';
        if (zakazka?.zakladovaDoskaDate) {
          startDate = zakazka?.zakladovaDoskaDate;
        } else if (zakazka?.hrubovaStavbaDate) {
          startDate = zakazka?.hrubovaStavbaDate;
        } else if (zakazka?.holodomDate) {
          startDate = zakazka?.holodomDate;
        } else if (zakazka?.domNaKlucDate) {
          startDate = zakazka?.domNaKlucDate;
        }
        const status = isInInterval(startDate, zakazka?.domNaKlucDateEnd ?? '');

        return getStatus(status);
      }
    }
  };

  const getStartingYear = (zakazka) => {
    if (zakazka) {
      if (zakazka.faza === 'hrubá stavba') {
        let startDate = '';
        if (zakazka?.zakladovaDoskaDate) {
          startDate = zakazka?.zakladovaDoskaDate;
        } else if (zakazka?.hrubovaStavbaDate) {
          startDate = zakazka?.hrubovaStavbaDate;
        }

        return startDate ? new Date(startDate).getFullYear() : '';
      } else if (zakazka.faza === 'holodom') {
        let startDate = '';
        if (zakazka?.zakladovaDoskaDate) {
          startDate = zakazka?.zakladovaDoskaDate;
        } else if (zakazka?.hrubovaStavbaDate) {
          startDate = zakazka?.hrubovaStavbaDate;
        } else if (zakazka?.holodomDate) {
          startDate = zakazka?.holodomDate;
        }

        return startDate ? new Date(startDate).getFullYear() : '';
      } else if (zakazka.faza === 'na kľúč') {
        let startDate = '';
        if (zakazka?.zakladovaDoskaDate) {
          startDate = zakazka?.zakladovaDoskaDate;
        } else if (zakazka?.hrubovaStavbaDate) {
          startDate = zakazka?.hrubovaStavbaDate;
        } else if (zakazka?.holodomDate) {
          startDate = zakazka?.holodomDate;
        } else if (zakazka?.domNaKlucDate) {
          startDate = zakazka?.domNaKlucDate;
        }

        return startDate ? new Date(startDate).getFullYear() : '';
      }
      return '';
    }
    return '';
  };

  const getStartingMonth = (zakazka) => {
    if (zakazka) {
      if (zakazka.faza === 'hrubá stavba') {
        let startDate = '';
        if (zakazka?.zakladovaDoskaDate) {
          startDate = zakazka?.zakladovaDoskaDate;
        } else if (zakazka?.hrubovaStavbaDate) {
          startDate = zakazka?.hrubovaStavbaDate;
        }

        return startDate ? new Date(startDate).getMonth() : '';
      } else if (zakazka.faza === 'holodom') {
        let startDate = '';
        if (zakazka?.zakladovaDoskaDate) {
          startDate = zakazka?.zakladovaDoskaDate;
        } else if (zakazka?.hrubovaStavbaDate) {
          startDate = zakazka?.hrubovaStavbaDate;
        } else if (zakazka?.holodomDate) {
          startDate = zakazka?.holodomDate;
        }

        return startDate ? new Date(startDate).getMonth() : '';
      } else if (zakazka.faza === 'na kľúč') {
        let startDate = '';
        if (zakazka?.zakladovaDoskaDate) {
          startDate = zakazka?.zakladovaDoskaDate;
        } else if (zakazka?.hrubovaStavbaDate) {
          startDate = zakazka?.hrubovaStavbaDate;
        } else if (zakazka?.holodomDate) {
          startDate = zakazka?.holodomDate;
        } else if (zakazka?.domNaKlucDate) {
          startDate = zakazka?.domNaKlucDate;
        }

        return startDate ? new Date(startDate).getMonth() : '';
      }
      return '';
    }
    return '';
  };
  const getEndDate = (zakazka) => {
    if (zakazka.faza === 'hrubá stavba') {
      return zakazka.hrubovaStavbaDateEnd ?? '-';
    } else if (zakazka.faza === 'holodom') {
      return zakazka.holodomDateEnd ?? '-';
    } else if (zakazka.faza === 'na kľúč') {
      return zakazka.domNaKlucDateEnd ?? '-';
    }
    return '-';
  };

  return { fazy, iconSet, stavy, statusSet, getEndDate, getStartingYear, getStartingMonth, years };
};
